export const environment = {
    production: true,
    // apiUrl: 'http://dev-vm:60000/api',
    // apiUrl: 'https://siwaorderpim.dev-vm.siwa.vpn/api',
    apiUrl: 'https://pim.orderfant.app/api',
    apiUrlPilot: 'https://siwaorderpim.pilot01.siwa.at/api',
    clientId: 1,
    stripe: {
        pk: 'pk_test_51GwiejBm3Ogsls4joyCrTAleMSuUy2XgVdNIKW0rafgjIb7jTLdyJs8iovRArAVezGtBRvJyRpwQF8xoXH2YQg6U00XLQvbu9S'
    },
    desktop: true
};
